import React from 'react';
import './Navigation.css';

const Navigation = () => {
  return (
    <nav className="navigation">
      <div className="nav-buttons">
        <button className="nav-btn active">市级</button>
        <button className="nav-btn">区县局</button>
        <button className="nav-btn">县级局</button>
      </div>
      
      <div className="search-filter">
        <input type="text" placeholder="搜索单位..." className="search-input" />
      </div>
      
      <div className="time-filter">
        <select className="filter-select">
          <option>本月</option>
          <option>本季度</option>
          <option>本年度</option>
          <option>自定义时间</option>
        </select>
      </div>
      
      <div className="indicator-filter">
        <select className="filter-select">
          <option>全部指标</option>
          <option>经营绩效</option>
          <option>运营管控</option>
          <option>卷烟营销</option>
          <option>专卖监管</option>
          <option>物流配送</option>
          <option>创新发展</option>
        </select>
      </div>
    </nav>
  );
};

export default Navigation;